import { render, staticRenderFns } from "./TransactionJournal.vue?vue&type=template&id=0c8d7e1d&scoped=true"
import script from "./TransactionJournal.vue?vue&type=script&lang=js"
export * from "./TransactionJournal.vue?vue&type=script&lang=js"
import style0 from "./TransactionJournal.vue?vue&type=style&index=0&id=0c8d7e1d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8d7e1d",
  null
  
)

export default component.exports